//BARILLA
export const FAKE_CAMPAIGN_RESULTS_1 = {
  brandId:'f8c6a1d8-68af-4161-9abd-9c187187098b',
  campaignId:'a248dedc-242e-4372-9799-2ea33b670031',
  averageRating:3.48,
  avgTimeSpent:36.5677017605561,
  budgetSpent:22032.4,
  totalBudget:22000,
  totalCompletions:55081,
  totalEngagements:222015,
  totalRatings:54318,
  totalTimeSpent:2916078,
  demoStatus:'complete'
};

export const FAKE_BRAND_RESULTS_1 = {
  brandId:'f8c6a1d8-68af-4161-9abd-9c187187098b',
  brandName:'Pasta Company',
  connectionCount:56000  
};

export const FAKE_ENGAGEMENT_RESULTS_1 = {
  "campaignId":"a248dedc-242e-4372-9799-2ea33b670031",
  "averageTime":38.0,
  "averageAdjoyability":2.0,
  "engagementKPIs":[
     {
      "engagementId":"1c6d4ce0-5fab-4a1a-9a5b-9ce406add3a8",
      "kind":"this_or_that",
      "responsesNum":9,
      "answerKPIs":[
         {
            "answer":"0",
            "answersNum":19684
         },
         {
            "answer":"1",
            "answersNum":36119
         }
      ]
     },
     {
      "engagementId":"b3742945-0582-4c6c-b790-aa2a6d44999b",
      "kind":"choose",
      "responsesNum":9,
      "answerKPIs":[
         {
            "answer":"241309fd-ac78-4b45-8e62-9b3ae6dac317",
            "answersNum":12351
         },
         {
            "answer":"737c9ba2-7aa8-466d-963b-757b293bfa0b",
            "answersNum":38461
         },
         {
            "answer":"7a5c76d9-94b0-4ee3-9cf3-0cf421ae16da",
            "answersNum":1038
         },
         {
            "answer":"90166cd2-9ef9-4a3a-90e4-c0b8af5dcaf0",
            "answersNum":3233
         }
      ]
     },
     {
      "engagementId":"613bddc4-f4c9-435b-abf8-b5e4f64f5bbd",
      "kind":"choose",
      "responsesNum":9,
      "answerKPIs":[
         {
            "answer":"38bf0e00-9ebc-4284-9e69-8b0124a1eea8",
            "answersNum":11189
         },
         {
            "answer":"95f371e8-b20c-48ef-8a9a-33339af5f6f1",
            "answersNum":3426
         },
         {
            "answer":"d7afb35e-733b-4480-aaf8-453aaafc1829",
            "answersNum":4086
         },
         {
            "answer":"f5cbf936-6cbb-4f90-b44e-cb2fb3b97d18",
            "answersNum":37329
         }
      ]
     },
     {
      "engagementId":"98ca580d-d591-417f-b368-7ad56f19372c",
      "kind":"ratable",
      "responsesNum":9,
      "answerKPIs":[
         {
            "answer":"0",
            "answersNum":946
         },
         {
            "answer":"1",
            "answersNum":54153
         }
      ]
     }
  ]
};

//CHEERIOS
export const FAKE_CAMPAIGN_RESULTS_2 = {
  brandId:'4b27f598-f959-48e7-8350-5974dd331821',
  campaignId:'aea54979-5b01-468a-be49-cc51f9a590e6',
  averageRating:3.42,
  avgTimeSpent:50.2293330719851,
  budgetSpent:50288,
  totalCompletions:71840,
  totalEngagements:431421,
  totalRatings:58459,
  totalTimeSpent:5677381,
  demoStatus:'complete'
};

export const FAKE_BRAND_RESULTS_2 = {
  brandId:'4b27f598-f959-48e7-8350-5974dd331821',
  brandName:'Cereal Company',
  connectionCount:71978  
};

export const FAKE_ENGAGEMENT_RESULTS_2 = {
  "campaignId":"aea54979-5b01-468a-be49-cc51f9a590e6",
  "averageTime":33.0,
  "averageAdjoyability":3.142857074737549,
  "engagementKPIs":[
     {
      "engagementId":"d7461df1-bcb0-484e-9261-b359b833e744",
      "kind":"choose",
      "responsesNum":11,
      "answerKPIs":[
         {
            "answer":"533fd2f7-2a0f-43ea-a04e-e4423daf80cd",
            "answersNum":4342
         },
         {
            "answer":"75c7dfdf-d09a-4750-bb94-2b534248ba41",
            "answersNum":21660
         },
         {
            "answer":"87eda4ef-7e9f-4632-8e6e-19b232547989",
            "answersNum":34903
         },
         {
            "answer":"9f87446c-7309-4c75-95df-6b250e893e89",
            "answersNum":10814
         }
      ]
     },
     {
      "engagementId":"60c698d5-8678-41f8-a6ce-6092c044163d",
      "kind":"this_or_that",
      "responsesNum":11,
      "answerKPIs":[
         {
            "answer":"0",
            "answersNum":26524
         },
         {
            "answer":"1",
            "answersNum":45199
         }
      ]
     },
     {
      "engagementId":"08bfd9c5-a221-4067-b526-c768f85c0a1a",
      "kind":"choose",
      "responsesNum":11,
      "answerKPIs":[
         {
            "answer":"21672fa8-bf70-47db-a197-75e9639371df",
            "answersNum":25072
         },
         {
            "answer":"348384c7-87ae-42ee-b5ff-f95cc431a2ea",
            "answersNum":3181
         },
         {
            "answer":"4de58ae3-10cd-4d77-8595-0bd83949484f",
            "answersNum":30788
         },
         {
            "answer":"8b8cdc64-f249-4990-be9e-40d59755299d",
            "answersNum":12742
         }
      ]
     },
     {
      "engagementId":"c415466b-2ebe-423e-bce3-0087f6ce4016",
      "kind":"choose",
      "responsesNum":11,
      "answerKPIs":[
         {
            "answer":"01697cbd-3155-4d6c-8ea4-a0fa7a91b8d8",
            "answersNum":29217
         },
         {
            "answer":"30e6b55d-ef3b-46ae-87f0-0b172ab5c9b8",
            "answersNum":42573
         }
      ]
     },
     {
      "engagementId":"1096a2c8-ff4f-4cd9-a7fb-8f3e03007a50",
      "kind":"choose",
      "responsesNum":11,
      "answerKPIs":[
         {
            "answer":"187a0ba4-912b-416f-9411-c0e82bd1cf2a",
            "answersNum":6745
         },
         {
            "answer":"cf861bae-e988-4f5d-9ec7-41746b5c0b77",
            "answersNum":2154
         },
         {
            "answer":"df131152-7743-4ebe-bad7-2cc2a7269d9f",
            "answersNum":42765
         },
         {
            "answer":"ec91dfd6-0c26-49ba-a677-b9e7d10bfd96",
            "answersNum":20133
         }
      ]
     },
     {
      "engagementId":"51f135f0-d500-4f24-aadb-a6a8faf6f410",
      "kind":"ratable",
      "responsesNum":11,
      "answerKPIs":[
         {
            "answer":"0",
            "answersNum":1331
         },
         {
            "answer":"1",
            "answersNum":70647
         }
      ]
     }
  ]
};

//FOLGERS
export const FAKE_CAMPAIGN_RESULTS_3 = {
  brandId:'c39facef-96cd-40f1-83d3-ee9a9a88bcba',
  campaignId:'dd2b6ca3-348e-463b-9a2a-26fda4348115',
  averageRating:3.43,
  avgTimeSpent:40.46781179985064,
  budgetSpent:34848,
  totalCompletions:69696,
  totalEngagements:348682,
  totalRatings:68593,
  totalTimeSpent:4908124,
  demoStatus:'active'
};

export const FAKE_BRAND_RESULTS_3 = {
  brandId:'c39facef-96cd-40f1-83d3-ee9a9a88bcba',
  brandName:'Coffee Company',
  connectionCount:69793
};

export const FAKE_ENGAGEMENT_RESULTS_3 = {
  campaignId:"dd2b6ca3-348e-463b-9a2a-26fda4348115",
  avgTimeSpent:40.46781179985064,
  averageRating:3.43,
  "engagementKPIs":[
     {
      "engagementId":"d27c5863-9221-4ed2-b976-f68246b432c1",
      "kind":"choose",
      "responsesNum":5,
      "answerKPIs":[
         {
            "answer":"3d35386a-6198-439c-98d3-430b45cb1f16",
            "answersNum":34067
         },
         {
            "answer":"6106b520-5afc-4d02-88a8-ff7fd138305c",
            "answersNum":5763
         },
         {
            "answer":"9e79eb2c-e97e-4e7a-a140-87b6426383d0",
            "answersNum":7313
         },
         {
            "answer":"a65ab747-e018-459b-9651-b3baf3b4aaab",
            "answersNum":43056
         }
      ]
     },
     {
      "engagementId":"a69096c0-7999-4ab5-8eaf-c4cc2cee8994",
      "kind":"choose",
      "responsesNum":5,
      "answerKPIs":[
         {
            "answer":"138601c0-c793-43ed-aa7b-3879c77de538",
            "answersNum":23870
         },
         {
            "answer":"258bf564-5c8f-4245-af96-582f3014bd4e",
            "answersNum":50024
         },
         {
            "answer":"7115112a-1928-418f-9191-bf29da952db5",
            "answersNum":10229
         },
         {
            "answer":"86cc156d-db80-4ad1-a0bf-451adc3eede2",
            "answersNum":6029
         }
      ]
     },
     {
      "engagementId":"c7bab4e4-122c-4b66-89d4-362ca4a82275",
      "kind":"choose",
      "responsesNum":5,
      "answerKPIs":[
         {
            "answer":"5085e1ad-f62b-4ca7-8381-0ccdbd7bb711",
            "answersNum":5498
         },
         {
            "answer":"ab710f88-4e6c-4031-bada-5f130e11c27e",
            "answersNum":41559
         },
         {
            "answer":"df54a912-a59d-4cd8-87a4-8bef54057441",
            "answersNum":20685
         },
         {
            "answer":"e68d5aa4-aabf-4070-9853-1bdf1d2ab492",
            "answersNum":22423
         }
      ]
     },
     {
      "engagementId":"384fb41f-babd-41b2-9f95-b4c691c964e7",
      "kind":"choose",
      "responsesNum":5,
      "answerKPIs":[
         {
            "answer":"712a98fa-9326-452a-9233-0c251d2d0f8d",
            "answersNum":25487
         },
         {
            "answer":"872c20c0-b2f4-4e9b-8719-14df3948e86d",
            "answersNum":46795
         },
         {
            "answer":"9530d2dc-0996-4e1b-8989-c963ca88d446",
            "answersNum":9449
         },
         {
            "answer":"cae67039-e0ae-4d3c-aa84-a99a80904b4d",
            "answersNum":8496
         }
      ]
     },
     {
      "engagementId":"7990e2eb-7a6c-459b-a5d7-28dede5436b8",
      "kind":"ratable",
      "responsesNum":90339,
      "answerKPIs":[
         {
            "answer":"0",
            "answersNum":2309
         },
         {
            "answer":"1",
            "answersNum":88030
         }
      ]
     }
  ]
};


// WEBPACK FOOTER //
// ./src/shared/redux/kpis/demoData.js